<jam-filter-options
    *ngIf="filterConfig"
    [filterConfig]="filterConfig"
    [remoteFilter]="remoteFilterCurrency"
    (remoteFilterChange)="setRemoteFilterCurrency($event)">
    </jam-filter-options>
